import React, { useState, useEffect } from "react";
import { searchObject } from "../services/stellariumservice";
import "./Encyclopedia.css";

export default function Encyclopedia() {
  const [objects, setObjects] = useState(() => {
    const saved = localStorage.getItem("astroData");
    return saved ? JSON.parse(saved) : [];
  });

  const [search, setSearch] = useState("");

  useEffect(() => {
    localStorage.setItem("astroData", JSON.stringify(objects));
  }, [objects]);

  async function handleSearch() {
  if (!search.trim()) return;

  const result = await searchObject(search);

  if (result.success) {
    setObjects(prev => {
      // remove duplicate if already searched
      const filtered = prev.filter(obj => obj.name !== result.name);

      // add new result at top
      const updated = [result, ...filtered];

      // keep only latest 10
      return updated.slice(0, 10);
    });

    setSearch("");
  } else {
    alert(result.message);
  }
}


  function deleteCard(name) {
    const updated = objects.filter(obj => obj.name !== name);
    setObjects(updated);
    localStorage.setItem("astroData", JSON.stringify(updated));
  }

  return (
    <div className="encyclopedia-page">
      <h1>Live Celestial Encyclopedia</h1>

      <div className="search-area">
        <input
          placeholder="Search astronomy/space related queries only"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      <div className="right-panel">
        {objects.map((object, index) => (
          <div className="astro-card" key={index}>
            <button
              className="delete-btn"
              onClick={() => deleteCard(object.name)}
            >
              cancel
            </button>

            <h2>{object.name}</h2>

            {object.image && (
              <img src={object.image} alt={object.name} />
            )}

            <p>{object.formation}</p>
            {/*<p><b>Evolution Stage:</b> {object.evolution_stage}</p>}
           {/*<p><b>Death Scenario:</b> {object.death_scenario}</p>*/}

            {object.observational_data && (
              <div>
                <p><b>RA:</b> {object.observational_data.ra}</p>
                <p><b>DEC:</b> {object.observational_data.dec}</p>
                <p><b>Magnitude:</b> {object.observational_data.magnitude}</p>
                <p><b>Constellation:</b> {object.observational_data.constellation}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
